import axios, { AxiosError, AxiosResponse } from 'axios';

import { simpleProjectServiceUrl } from '../../config/environment';
import { BackendHttpError } from '../../services/axiosConfig';

export const getUserProfileById = async (id: string): Promise<SimpleProjectServiceAPI.UserDto> => {
  const response:
    | AxiosResponse<SimpleProjectServiceAPI.UserDto[]>
    | AxiosError<BackendHttpError> = await axios.post(
    `${simpleProjectServiceUrl}/api/v1/user-profile/get-list`,
    [id],
  );

  if (response instanceof Error) {
    throw response;
  }

  return response.data[0];
};
